import { FileText, Upload } from 'lucide-react';

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;

export const UploadDropzone = ({ dropzone, selectedFile }) => {
  const { getRootProps, getInputProps, isDragActive } = dropzone;

  return (
    <div
      {...getRootProps()}
      data-testid="dropzone"
      className={`cursor-pointer rounded-sm border-2 border-dashed p-8 text-center transition-all duration-300 ${
        isDragActive
          ? 'border-white bg-white/5'
          : 'border-zinc-800 hover:border-zinc-700 hover:bg-zinc-900/30'
      }`}
    >
      <input {...getInputProps()} data-testid="file-input" />
      <Upload className="mx-auto mb-4 h-12 w-12 text-zinc-600" />
      {selectedFile ? (
        <div className="space-y-2">
          <div className="flex items-center justify-center gap-2 text-white">
            <FileText className="h-5 w-5" />
            <span className="font-medium">{selectedFile.name}</span>
          </div>
          <p className="text-xs text-muted-foreground">
            {(selectedFile.size / BYTES_PER_MB).toFixed(2)} MB
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          <p className="text-zinc-400">
            {isDragActive ? 'Déposez le fichier ici' : 'Glissez-déposez un PDF ou cliquez'}
          </p>
          <p className="text-xs text-zinc-600">PDF uniquement, max 50 MB</p>
        </div>
      )}
    </div>
  );
};
